import { FC } from 'react';

import { useViewportStore } from '../../../lib';
import { Button } from '../../button';
import { DialogClose } from '../../dialog';
import { DrawerClose } from '../../drawer';
import { ModalTemplate } from '../../templates';
import { IConfirmModal } from './types';

const BackButton: FC = () => {
  const isMobile = useViewportStore((state) => state.isMobile);

  const renderBackButton = () => {
    return (
      <Button variant="base-300" size="lg" className="w-full">
        No, back
      </Button>
    );
  };
  if (isMobile) {
    return (
      <DrawerClose asChild className="w-full">
        {renderBackButton()}
      </DrawerClose>
    );
  }
  return (
    <DialogClose asChild className="w-full">
      {renderBackButton()}
    </DialogClose>
  );
};

export const ConfirmModal: FC<IConfirmModal> = ({
  onConfirm,
  isDisabled,
  isLoading,
  title,
  description,
  confirmText = 'Yes, submit',
}) => {
  return (
    <ModalTemplate
      id="Confirm modal"
      classNames={{
        wrapper: 'rounded-[32px]',
      }}
    >
      <div className="px-6 pb-2 pt-10 text-center">
        <h1 className="text-center heading-s">{title}</h1>
        {description && (
          <p className="mt-3 text-base-300 typography-14r">{description}</p>
        )}
      </div>
      <div className="flex gap-1 px-1 pb-1 pt-5">
        <div className="w-full flex-1">
          <BackButton />
        </div>
        <div className="w-full flex-1">
          <Button
            size="lg"
            className="w-full"
            onClick={onConfirm}
            disabled={isDisabled}
            loading={isLoading}
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </ModalTemplate>
  );
};
